// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-details-sidebar {
  padding: 0 24px;
}


.contact-details-avatar {
  --avatar-size: 80px;
  --presence-size: calc(var(--avatar-size) * 0.2);
  --presence-border: calc(var(--avatar-size) * 0.0375);
  display: flex;
  justify-content: center;
  margin-top: 32px;
  margin-bottom: 16px;
  position: relative;
  width: var(--avatar-size);
  height: var(--avatar-size);
  margin-left: auto;
  margin-right: auto;
}

.contact-details-avatar-img {
  width: var(--avatar-size);
  height: var(--avatar-size);
  border-radius: 50%;
  object-fit: cover;
}

.contact-details-presence-indicator {
  position: absolute;
  bottom: calc(var(--avatar-size) * 0.075);
  right: calc(var(--avatar-size) * 0.075);
  width: var(--presence-size);
  height: var(--presence-size);
  border-radius: 50%;
  border: var(--presence-border) solid white;
  background-color: #cccccc;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.contact-details-name {
  font-family: Roboto, arial, sans-serif;
  font-weight: 700;
  font-size: 21px;
  text-align: center;
  margin-bottom: 8px;
}

.contact-details-info {
  margin-bottom: 8px;
}

.contact-details-presence {
  font-size: 13px;
  color: #4caf50;
  margin-bottom: 8px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/RightSidebar/ContactDetailsSidebar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;;AAGA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,oDAAoD;EACpD,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,uCAAuC;EACvC,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".contact-details-sidebar {\n  padding: 0 24px;\n}\n\n\n.contact-details-avatar {\n  --avatar-size: 80px;\n  --presence-size: calc(var(--avatar-size) * 0.2);\n  --presence-border: calc(var(--avatar-size) * 0.0375);\n  display: flex;\n  justify-content: center;\n  margin-top: 32px;\n  margin-bottom: 16px;\n  position: relative;\n  width: var(--avatar-size);\n  height: var(--avatar-size);\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.contact-details-avatar-img {\n  width: var(--avatar-size);\n  height: var(--avatar-size);\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.contact-details-presence-indicator {\n  position: absolute;\n  bottom: calc(var(--avatar-size) * 0.075);\n  right: calc(var(--avatar-size) * 0.075);\n  width: var(--presence-size);\n  height: var(--presence-size);\n  border-radius: 50%;\n  border: var(--presence-border) solid white;\n  background-color: #cccccc;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  z-index: 2;\n}\n\n.contact-details-name {\n  font-family: Roboto, arial, sans-serif;\n  font-weight: 700;\n  font-size: 21px;\n  text-align: center;\n  margin-bottom: 8px;\n}\n\n.contact-details-info {\n  margin-bottom: 8px;\n}\n\n.contact-details-presence {\n  font-size: 13px;\n  color: #4caf50;\n  margin-bottom: 8px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
